import React, { forwardRef } from "react";
import moment from "moment";

const NotificationPanel = forwardRef(
  ({ groupedNotifications = {}, isNotificationOpen = false }, ref) => {
    return (
      <div
        ref={ref}
        className={`${
          isNotificationOpen ? "translate-x-0 " : "translate-x-[100%]"
        } transition-all fixed w-full md:w-[400px] lg:w-[440px]  top-[85px] bottom-0 right-0 px-3 pt-3 bg-black/70 backdrop-blur-sm z-50 overflow-y-auto max-h-[calc(100vh-85px)] `}
      >
        {Object.keys(groupedNotifications).length === 0 ? (
          <div className="text-center text-white/60 py-10">
            <p className="text-sm">📭 No notifications available</p>
          </div>
        ) : (
          Object.keys(groupedNotifications).map((dateGroup) => (
            <div key={dateGroup}>
              <h2 className="text-white font-bold text-sm mb-2 mt-4">
                {dateGroup}
              </h2>
              {groupedNotifications[dateGroup].map((item, idx) => (
                <div
                  key={item.id || idx}
                  className={`${
                    !item.read
                      ? "bg-[linear-gradient(292deg,_#730000_0%,_#000000_75%,_#000000_100%)] border border-[#730000] text-white"
                      : "border bg-black border-white/20 text-white"
                  } rounded-lg p-3 mb-3 flex items-start gap-2`}
                >
                  <span className="text-yellow-400 mt-1">🔔</span>
                  <div className="w-full">
                    <h4 className="font-semibold text-sm">{item.title}</h4>
                    <p
                      className={`text-xs ${
                        !item.read ? "text-white" : "text-white/80"
                      }`}
                    >
                      {item.body}
                    </p>
                    <p
                      className={`${
                        !item.read ? "text-white" : "text-white/50"
                      } text-[10px] text-end mt-1`}
                    >
                      {moment(item.createdAt).format("MMM D, YYYY • hh:mm A")}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    );
  }
);

export default NotificationPanel;
